import React from 'react';
import PropTypes from 'prop-types';
import YellowGreenButton from './YellowGreenButton';
import SlotInfo from './SlotInfo';
import i18n from '../utils/i18n';
import {
  disableBookStatuses,
  bookingAvailabilityStatusesMessages
} from '../utils/constants';
import './styles/CourtCard.scss';

class CourtCard extends React.Component {
  getDisplayedButtonText() {
    const {
      availableSpaces,
      bookingAvailabilityStatus
    } = this.props;
    let displayedButtonText = i18n.t('courtsScreen.BOOK_COURT');

    const buttonDisabled =
      disableBookStatuses.indexOf(bookingAvailabilityStatus) !== -1;

    if (buttonDisabled) {
      displayedButtonText = bookingAvailabilityStatusesMessages[bookingAvailabilityStatus];
    } else if (availableSpaces === 1) {
      displayedButtonText =
        `${i18n.t('courtsScreen.BOOK')} - ` +
        `1 ${i18n.t('courtsScreen.COURT_LEFT')}`;
    }

    return displayedButtonText;
  }

  render() {
    const {
      time,
      clubName,
      clubAddress,
      courtType,
      startQuickBooking,
      bookingAvailabilityStatus
    } = this.props;

    const buttonDisabled =
      disableBookStatuses.indexOf(bookingAvailabilityStatus) !== -1;

    const displayedButtonText = this.getDisplayedButtonText();

    return (
      <div className="court-card">
        <div className="slot-info-container">
          <SlotInfo date={time} clubName={clubName} address={clubAddress} />
        </div>
        <div className="court-type">
          <strong>
            {courtType} {i18n.t('courtsScreen.COURT')}
          </strong>
        </div>
        <hr />
        <YellowGreenButton
          onClick={startQuickBooking}
          text={displayedButtonText}
          buttonClass={buttonDisabled ? 'disabled-button' : ''}
          disabled={buttonDisabled}
          style={{
            width: '200px',
            marginTop: '20px'
          }}
        />
      </div>
    );
  }
}

CourtCard.propTypes = {
  availableSpaces: PropTypes.number,
  time: PropTypes.string,
  clubName: PropTypes.string,
  clubAddress: PropTypes.string,
  courtType: PropTypes.string,
  startQuickBooking: PropTypes.func,
  bookingAvailabilityStatus: PropTypes.string
};

CourtCard.defaultProps = {
  availableSpaces: 0,
  time: '',
  clubName: '',
  clubAddress: '',
  courtType: '',
  startQuickBooking: () => {},
  bookingAvailabilityStatus: ''
};

export default CourtCard;



// WEBPACK FOOTER //
// ./src/components/CourtCard.js